import script from "./DeviceLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceLayout.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceLayout.vue?vue&type=style&index=0&id=7720aa5f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7720aa5f"]])

export default __exports__